<template>
  <div class="n-toast">
    <div class="toast-box" :class="`toast-${color}`">
      <div class="toast-icon" v-if="icon">
        <b-icon :icon="icon"/>
      </div>
      <div class="toast-message">{{message}}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "n-toast",
  props: {
    toast: {}
  },
  data() {
    return {
      icon: null,
      message: '',
      color: 'primary'
    }
  },
  created() {
    if (this.toast.icon) this.icon = this.toast.icon
    if (this.toast.message) this.message = this.toast.message
    if (this.toast.color && ['primary', 'success', 'warning', 'danger', 'secondary'].includes(this.toast.color)) this.color = this.toast.color
  }
}
</script>

<style lang="scss">
.n-toast {

  .toast-box {
    margin-top: -1px;
    padding: 0 14px;
    display: flex;
    align-items: center;
    min-height: 60px;
    line-height: 1.6;
    font-weight: 600;
    font-size: 14.5px;

    .toast-icon {
      margin-left: 10px;
      display: flex;

      .b-icon {
        vertical-align: middle !important;
        font-size: 26px;
      }
    }

    &.toast-primary {
      background: var(--brand-700);
      color: #ffffff;
    }

    &.toast-success {
      background: #1F8A5B;
      color: #ffffff;
    }

    &.toast-warning {
      background: var(--accent);
      color: var(--brand-950);
    }

    &.toast-danger {
      background: #C2362F;
      color: #ffffff;
    }

    &.toast-secondary {
      background: var(--surface);
      color: var(--brand-800);
      border-bottom: 1px solid var(--border);
    }
  }

  @media (min-width: 992px) {
    margin-bottom: 10px;

    .toast-box {
      margin: 0;
      min-height: 56px;
      border-radius: var(--radius-lg);
      box-shadow: var(--shadow-lg);
      padding: 0 16px;
    }
  }
}
</style>
